import { formatToTwDate } from '@/utils/is/dateUtils';
import { getInfoAC, submitAC } from '@/apis/AC';

export function validPayDate(isShowPayDate, payDate, maxPayDate, minPayDate) {
    if (isShowPayDate && (new Date(payDate) < new Date(minPayDate) || new Date(payDate) > new Date(maxPayDate))) {
        return `${formatToTwDate(payDate)}未介於${formatToTwDate(minPayDate)}~${formatToTwDate(maxPayDate)}`;
    } else {
        return '';
    }
}

/**
 * 設定頁面資料綁定物件
 * @param {*} data vue資料綁定物件
 * @param {ComputedRef<any>} result 交易項目的store物件
 */
export function setData(data, result) {
    if (!result.value) {
        getData(data);
    } else {
        const {
            storeInputData,
            storeShowData,
            storeFlagData,
        } = result.value;
        const {
            payDate,
            payWay,
            payPeriod,
            ensurePeriod,
        } = storeInputData;
        data.inputData.payDate = payDate;
        data.inputData.payWay = payWay;
        data.inputData.payPeriod = payPeriod;
        data.inputData.ensurePeriod = ensurePeriod;
        data.showData = storeShowData;
        data.flagData = storeFlagData;
    }
    data.isGettingData = 0;
}

export function getData(data) {
    // setTestData(data);
    data.isGettingData = 1;
    getInfoAC().then((res) => {
        data.showData.payDate = res.data.giveDate;
        data.showData.effectDate = res.data.effectDate;
        data.showData.minPayDate = res.data.minPayDate;
        data.showData.maxPayDate = res.data.maxPayDate;
        data.showData.payWay = res.data.payMode;
        data.showData.payWayText = res.data.payModeCH;
        data.showData.payPeriod = res.data.payPeriod;
        data.showData.ensurePeriod = res.data.pledgePeriod;
        data.flagData.isShowPayDate = res.data.item1YN === 'Y';
        data.flagData.isShowPayWay = res.data.option !== null && res.data.option.length > 0;
        data.flagData.isShowPayPeriod = res.data.item2YN === 'Y';
        data.flagData.isShowEnsurePeriod = res.data.item3YN === 'Y';
        data.inputData.payDate = data.showData.payDate;
        data.inputData.payWay = data.showData.payWay;
        data.inputData.payPeriod = data.showData.payPeriod;
        data.inputData.ensurePeriod = data.showData.ensurePeriod;

        data.showData.payWayList = res.data.option;
        data.showData.payPeriodList = res.data.payPeriodOption;
        data.showData.ensurePeriodList = res.data.pledgePeriodOption;
        data.showData.minPayDate = res.data.startDay;
        data.showData.maxPayDate = res.data.endDay;
        data.showData.noteList = res.data.note;
    }).finally(() => {
        // if (data.flagData.isShowPayWay) {
        //     data.isGettingData += 1;
        // }
        // if (data.flagData.isShowPayPeriod) {
        //     data.isGettingData += 1;
        // }
        // if (data.flagData.isShowEnsurePeriod) {
        //     data.isGettingData += 1;
        // }
        data.isGettingData -= 1;
    });

    // if (data.flagData.isShowPayWay) {
    //     getPayWayInfo().then((res) => {
    //         data.showData.payWayList = res.data.payWayList;
    //     }).finally(() => {
    //         data.isGettingData -= 1;
    //     });
    // }
    // if (data.flagData.isShowPayPeriod) {
    //     getPayPeriodInfo().then((res) => {
    //         data.showData.payPeriodList = res.data.payPeriodList;
    //     }).finally(() => {
    //         data.isGettingData -= 1;
    //     });
    // }
    // if (data.flagData.isShowEnsurePeriod) {
    //     getEnsurePeriodInfo().then((res) => {
    //         data.showData.ensurePeriodList = res.data.ensurePeriodList;
    //     }).finally(() => {
    //         data.isGettingData -= 1;
    //     });
    // }
}

export function modalShow($vfm, params) {
    $vfm.show({
        component: 'DialogBase',
        params,
        on: {
            confirm() {
                $vfm.hide('DialogBase');
            },
            closed() {
                $vfm.hide('DialogBase');
            },
        },
    });
}

export function submitData(data, store, code) {
    data.isGettingData = 1;
    const returnData = {
        giveDate: data.flagData.isShowPayDate ? data.inputData.payDate.replaceAll('/', '-') : '',
        payMode: data.flagData.isShowPayWay ? data.inputData.payWay : '',
        payPeriod: data.flagData.isShowPayPeriod ? data.inputData.payPeriod : '',
        pledgePeriod: data.flagData.isShowEnsurePeriod ? data.inputData.ensurePeriod : '',
    };
    submitAC(returnData).then(() => {
        data.isSubmitOk = true;
        const value = {
            storeFlagData: data.flagData,
            storeShowData: data.showData,
            storeInputData: data.inputData,
        };
        store.dispatch('services/setChangeItemsResult', {
            code,
            value,
        });
    }).catch(() => {
        data.isGettingData = 0;
    }).finally(() => {
        data.isGettingData = 0;
    });
}
